import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";

const ChipCardDivider = ({label, line = true}) => {
    const chipWithLine = (
        <Divider light variant="middle" sx={{mt: 3, mx: 0, mb: 2}}>
            <Chip label={label} sx={{fontWeight: "light"}} />
        </Divider>
    );

    const chipWithNoLine = (
        <div style={{display: "flex", justifyContent: "center"}}>
            <Chip
                label={label}
                sx={{position: "relative", mb: 2, fontWeight: "light"}}
            />
        </div>
    );

    return line ? chipWithLine : chipWithNoLine;
};

export default ChipCardDivider;
